import {
  HsAppointmentStatusType,
  HsCalendarAppointment,
} from '@hsetu/ngui-views';
import { Appointment } from '../models/appointment.model';
import { Task } from '../models/task.model';

export class AppointmentMapper {
  public toLocalISOString(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
      `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    );
  }

  private parseLocalDate(value: unknown): Date {
    const s = String(value);
    // Strip trailing 'Z' or timezone offset so the browser parses as local time,
    // matching the local ISO string we send to the server.
    const local = s.replace(/Z$/, '').replace(/[+-]\d{2}:\d{2}$/, '');
    return new Date(local);
  }

  public mapAppointmentRequest(data: Appointment) {
    const startDate = new Date(String(data.startDate));
    const endDate = new Date(String(data.endDate));
    const request = {
      UId: data.uId,
      InfoDesc: data.infoDesc,
      StartDate: this.toLocalISOString(startDate),
      EndDate: this.toLocalISOString(endDate),
      Subject: data.subject,
      Author: data.author,
      TaskId: data['task'] ? data['task'].uId : undefined,
      CustomerId: data.customer ? data.customer.uId : undefined,
      LocationId: data.location ? data.location.uId : undefined,
    };

    return request;
  }

  public mapToHsCalendarAppointment(data: Appointment): HsCalendarAppointment {
    return {
      uId: data.uId,
      startDate: this.parseLocalDate(data.startDate),
      endDate: this.parseLocalDate(data.endDate),
      name: data.subject ?? data.infoDesc ?? '',
      bodyText: data.infoDesc ?? '',
      statusType: HsAppointmentStatusType.notStarted,
    };
  }

  public appointmentMap(a: Appointment): Appointment {
    a.stampCreate = new Date(String(a.stampCreate)).toISOString();
    a.stampEdit = a.stampEdit
      ? new Date(String(a.stampEdit)).toISOString()
      : undefined;
    a.startDate = this.parseLocalDate(a.startDate);
    a.endDate = this.parseLocalDate(a.endDate);
    return a;
  }

  public taskAppointmentMap(x: Task): Task {
    x.stampCreate = new Date(String(x.stampCreate)).toISOString();
    x.stampEdit = x.stampEdit
      ? new Date(String(x.stampEdit)).toISOString()
      : undefined;

    if (x.appointment) {
      x.appointment.startDate = this.parseLocalDate(x.appointment.startDate);
      x.appointment.endDate = this.parseLocalDate(x.appointment.endDate);
    }

    if (x.statusHistory && x.statusHistory.length > 0) {
      x.statusHistory.map((s) => {
        s.stampCreate = new Date(String(s.stampCreate)).toISOString();
        s.stampEdit = s.stampEdit
          ? new Date(String(s.stampEdit)).toISOString()
          : undefined;
        return s;
      });
    }

    if (x.items && x.items.length > 0) {
      x.items.map((i) => {
        i.stampCreate = new Date(String(i.stampCreate)).toISOString();
        i.stampEdit = i.stampEdit
          ? new Date(String(i.stampEdit)).toISOString()
          : undefined;
        return i;
      });
    }

    return x;
  }
}
